export var ADD_FILTER_TYPE = '@hivemind-common/ADD_FILTER_TYPE';
export var SET_FILTER = '@hivemind-common/SET_FILTER';
export var SET_FILTER_OPTIONS = '@hivemind-common/SET_FILTER_OPTIONS';